<template>
  <div
    class="overflow-hidden duration-300"
    :class="{
      'animate__animated animate__shakeX ': animationIsVisible,
      'h-[15rem] md:h-[11rem]': !hideOnCurrentMenu,
      'h-[0]': hideOnCurrentMenu,
    }"
  >
    <PlatformAccessSubscriber
      ref="platformAccessSubscriber"
      v-if="!hideOnCurrentMenu"
    />
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <AppDataProperty
      contentId="platformAccessSubscription"
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData || {}
        }
      "
    />
    <div class="px-8 pt-4 pb-2">
      <div
        class="w-full shadow-t-lg border-2 border-white rounded-2xl relative overflow-hidden"
      >
        <div
          class="absolute w-full h-full"
          style="background: linear-gradient(to bottom, #ffdddc 10%, #fffcfc)"
        ></div>

        <div class="flex gap-4 items-center p-4 md:p-4 relative">
          <div
            class="rounded-full min-w-14 w-14 h-14 shadow-b-2xl p-0 bg-[#ffc8c6] mb-auto md:mb-0"
          >
            <div class="p-2">
              <LottieComponent :src="alertCircleLottie" loop />
            </div>
          </div>
          <div class="flex w-full flex-col md:flex-row gap-2">
            <div>
              <div class="text-base md:text-xl title-color">
                Activez votre compte Ekidiscount
              </div>
              <div class="text-xs md:text-sm">
                Choissiez le plan parfait pour vous
              </div>
            </div>
            <div class="md:ml-auto min-w-max">
              <div>
                <router-link
                  to="/pro"
                  class="buttonComponent py-4 px-6 rounded-2xl text-sm md:test-lg"
                >
                  Plans
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EventListener
      :events="['platform_access_required']"
      @platform_access_required="displayAnimation"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserProperty from '../user/UserProperty.vue'
import AppDataProperty from '../appData/AppDataProperty.vue'
import alertCircleLottie from '@/assets/lotties/alertCircle.json'
import notificationLottie from '@/assets/lotties/notification-V4.json'
import LottieComponent from '../utils/LottieComponent.vue'
import PlatformAccessSubscriber from './PlatformAccessSubscriber.vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'UserValidationTopSection',
  components: {
    PlatformAccessSubscriber,
    UserProperty,
    AppDataProperty,
    LottieComponent,
    EventListener,
  },
  props: {},
  data() {
    return {
      userData: {},
      platformAccessSubscription: {},
      hideModal: false,
      animationIsVisible: false,
      alertCircleLottie,
      notificationLottie,
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    displayAnimation() {
      this.animationIsVisible = true
      setTimeout(() => {
        this.animationIsVisible = false
      }, 2000)
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Action requise',
        body: 'Paiement requis pour utiliser les fonctionnalités de Ekidiscount',
      })
    },
  },
  computed: {
    hideOnCurrentMenu() {
      if (this.$route.name == 'proSubscription') return true
      return false
    },
  },
  watch: {},
})
</script>
